export const FeedLinkStyles = {
    BUTTON: 'BUTTON',
    HYPERLINK: 'HYPERLINK',
};
